module.exports = __webpack_public_path__ + "img/file-download.664e47dd.svg";